export const MIN_TIME_SEC_RECORD = 20;

export const TIME_SEC_TO_REDIRECT = 10;

export const ONE_SEC = 1000;
export const PROGRESS_STEP_VALUE = 4;
